import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const Background = styled.div`
    width: 100%;
    background-color: ${(props) => props.theme.primaryColor.white[4]};
    display: flex;
    padding: 64px 0px;
    align-items: center;
    justify-content: center;
`

export const MainContainer = styled.div`
    max-width: ${(props) => props.theme.containerWidth};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    padding: 0px 16px;
    position: relative;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        padding: unset;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        padding: 16px 0px;
    }
`

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    h2 {
        font-family: Yantramanav-Bold;
        letter-spacing: -3px;
        font-size: 64px;
        margin-bottom: -32px;
        margin: unset;
        transition: color 0.3 ease;
        color: ${(props) => props.theme.primaryColor.blue[3]};
    }

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        max-width: 536px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        margin: 0px 16px;
        h2 {
            font-size: 48px;
        }
    }
`

export const CardWrapper = styled.div`
    display: inline-grid;
    grid-template-columns: auto auto auto auto;
    width: 100%;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        grid-template-columns: repeat(2, auto);
        justify-content: center;
        gap: 16px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        grid-template-columns: repeat(1, auto);
    }
`

export const Card = styled(Link)`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    width: 228px;
    gap: 24px;
    background-color: ${(props) => props.theme.primaryColor.white[2]};
    height: 432px;
    color: ${(props) => props.theme.primaryColor.grey[2]};
    padding: 16px 16px 0px 16px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);

    &:hover {
        background-color: ${(props) => props.theme.primaryColor.blue[1]};
        color: ${(props) => props.theme.primaryColor.white[1]};
    }

    h3 {
        color: ${(props) => props.theme.primaryColor.blue[3]};
        font-family: Inter-ExtraBold;
        font-size: 20px;
        margin: unset;
        transition: color 0.3 ease;
    }

    &:hover h3 {
        color: ${(props) => props.theme.primaryColor.white[1]};
    }
`

export const FloatingSquareImage = styled.img`
    position: absolute;
    bottom: -15%;
    right: calc(50% - 540px);
    width: 33px;
    height: 92px;
    object-fit: cover;
    z-index: 5;

    @media (max-width: ${(props) => props.theme.breakPoints.miniTablet}) {
        left: 16px;
        bottom: -8%;
        left: calc(50% + 250px);
        width: 27px;
        height: 81px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        left: 16px;
        bottom: -5%;
        left: calc(50% + 100px);
    }
`
